import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WeeklyMode.css';

const WeeklyCompleted: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState('');

  // Countdown to midnight Paris time (next day)
  useEffect(() => {
    function updateCountdown() {
      const now = new Date();
      // Calculate next midnight in Paris timezone
      const parisNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Paris' }));
      const tomorrow = new Date(parisNow);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);

      // Approximate diff (good enough for UI)
      const diff = Math.max(0, Math.floor((tomorrow.getTime() - parisNow.getTime()) / 1000));
      const h = Math.floor(diff / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      setCountdown(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`);
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="weekly-container">
      <div className="weekly-completed">
        <div className="weekly-completed-emoji">🎉</div>
        <h2 className="weekly-completed-title">Thème du jour terminé !</h2>
        <p className="weekly-completed-desc">
          Tu as répondu à toutes les questions du jour. Reviens demain pour un nouveau thème !
        </p>

        <div className="weekly-completed-next">
          <div className="weekly-completed-next-label">⏳ Prochain thème dans</div>
          <div className="weekly-completed-next-theme">{countdown}</div>
        </div>

        <button className="weekly-completed-btn" onClick={() => navigate('/weekly')} style={{ marginBottom: 12 }}>
          ← Retour au Hub Weekly
        </button>
        <br />
        <button className="weekly-completed-btn" onClick={() => navigate('/')} style={{ background: 'rgba(255,255,255,0.08)' }}>
          🏠 Retour au Lobby
        </button>
      </div>
    </div>
  );
};

export default WeeklyCompleted;
